<script>
import { ref, onMounted } from "vue";
import AppNav from "@/components/AppNav.vue";
import AppBestSeller from "@/components/AppBestSeller.vue";
import AppCategory from "@/components/AppCategory.vue";
import AppElegant from "@/components/AppElegant.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppLoader from "@/components/AppLoader.vue";

export default {
  name: "HomeView",
  components: {
    AppNav,
    AppBestSeller,
    AppCategory,
    AppElegant,
    AppFooter,
    AppLoader,
  },
  setup() {
    const loginIn = ref(true);

    onMounted(() => {
      setTimeout(() => {
        loginIn.value = false;
      }, 3000);
    });
    return {
      loginIn,
    };
  },
};
</script>

<template>
  <div v-if="loginIn">
    <AppLoader />
  </div>
  <div v-else>
    <AppNav />
    <v-carousel
      :show-arrows="false"
      hide-delimiters
      cycle
      height="1000"
      class="img-carousel"
    >
      <v-carousel-item src="background.png" cover></v-carousel-item>
      <v-carousel-item src="background1.png" cover></v-carousel-item>
      <v-carousel-item src="background2.png" cover></v-carousel-item>
    </v-carousel>
    <AppCategory />
    <AppBestSeller />
    <AppElegant />
    <hr />
    <AppFooter />
  </div>
</template>

<style lang="scss" scoped>
hr {
  height: 1px;
  background-color: #000;
}

.image {
  height: 100%;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .img-carousel {
    height: 500px !important;
  }
}
</style>
